import axios from "axios";
import { HTTP_STATUS } from "@/constants/HttpStatusCode";
import { moduleActionContext } from "..";
import { defineModule } from "direct-vuex";

export interface DataState {
  filteredCounties: [];
  scheduleCounties: [];
}

const dataModule = defineModule({
  namespaced: true,
  state: {
    filteredCounties: [],
    scheduleCounties: [],
  } as DataState,
  getters: {
    getFilteredCountiesInStore: (state: DataState) => state.filteredCounties,
    getScheduleCountiesInStore: (state: DataState) => state.scheduleCounties,
  },
  mutations: {
    SET_FILTERED_COUNTIES(state: DataState, newFilteredCounties: []) {
      state.filteredCounties = newFilteredCounties;
    },
    SET_SCHEDULE_COUNTIES(state: DataState, newScheduleCounties: []) {
      state.scheduleCounties = newScheduleCounties;
    },
  },
  actions: {
    getFilteredCounties(context: any, url: string) {
      const { commit, rootDispatch } = dataModuleActionContext(context);

      axios
        .get(url)
        .then((response) => {
          if (response.status === HTTP_STATUS.OK) {
            const resObj: any = response.data;
            commit.SET_FILTERED_COUNTIES(resObj);
          }
        })
        .catch(() => {
          rootDispatch.alertModule.showAlertMessageByGPC("ER_INLINE");
        });
    },
    getScheduleCounties(context: any, url: string) {
      const { commit, rootDispatch } = dataModuleActionContext(context);

      axios
        .get(url)
        .then((response) => {
          if (response.status === HTTP_STATUS.OK) {
            const resObj: any = response.data;
            commit.SET_SCHEDULE_COUNTIES(resObj);
          }
        })
        .catch(() => {
          rootDispatch.alertModule.showAlertMessageByGPC("ER_INLINE");
        });
    },
  },
});

export default dataModule;
const dataModuleActionContext = (context: any) =>
  moduleActionContext(context, dataModule);
